import { axiosInstance } from "../../utils/axios";
import { CreateDocumentRequest, DocumentItem } from "../../redux/feature/document/document-slice";
import { AxiosError } from "axios";
import { DocumentPart } from "../models";
import { TgkElaborationResponse } from "../models/tgk-elaboration-response";
import { TgkImpExpElaborationRequest } from "../models/tgk-imp-exp-elaboration-request";
import { TgkDuplicateElaborationRequest } from "../models/tgk-duplicate-elaboration-request";
import { CheckDuplicate } from "../models/check-duplicate";
import { TgkDetachElaborationRequest } from "../models/tgk-detach-elaboration-request";
import { DocumentUrlProtectionType } from "../models/documenturl-protectiontype";
import { TgkCloneElaborationRequest } from "../models/tgk-clone-elaboration-request";
import { AxiosWrappedApiCall } from "../../utils/helpers/axios.helpers";
import { TgkDownloadCopyElaborationRequest } from "../models/tgk-download-elaboration-request";
import { EVENT_CHANNEL_DEFAULT_TOPIC } from "../../utils/constants/eventChannel";
import * as uuid from "uuid";
import { DownloadDocumentStructure } from "../../pages/document/DownloadCopyPage/DownloadCopyPage";

export function fetchDocuments(): Promise<DocumentPart[]> {
  return axiosInstance.get("/documentpart").then((resp) => resp.data);
}

export function fetchDocumentUrl(id: string): Promise<DocumentUrlProtectionType> {
  return axiosInstance.get(`/documentpart/${id}/url`).then((resp) => {
    // eslint-disable-next-line no-undef
    console.log("Protection type ::::::" + resp.data.protectionType);
    return resp.data;
  });
}

export function fetchDocumentWebUrl(id: string): Promise<DocumentUrlProtectionType> {
  return axiosInstance.get(`/documentpart/${id}/weburl`).then((resp) => {
    // eslint-disable-next-line no-undef
    console.log("Protection type ::::::" + resp.data.protectionType);
    return resp.data;
  });
}

export const fetchDocumentPath: AxiosWrappedApiCall<string, [sharepointId: string]> = (sharepointId, config) => {
  return axiosInstance.get(`/documentpart/${sharepointId}/path`, config).then((resp) => resp.data);
};

export async function fetchCreatedDocument(item: CreateDocumentRequest): Promise<DocumentItem> {
  // eslint-disable-next-line no-undef
  let response: DocumentItem;
  try {
    let req = await axiosInstance.post("/documentpart/create", JSON.stringify(item));
    // eslint-disable-next-line no-undef
    response = req.data;
    response.error = [];
  } catch (error) {
    const err = error as AxiosError;
    if (err.response) {
      return {
        error: [err.response.data],
      };
    }
  }
  return response;
}

export function deleteDocumentRoot(docPartRootId: string, currentDocumentPartId?: string): Promise<string[]> {
  return axiosInstance
    .delete(
      `documentpart/${docPartRootId}/delete` +
        (currentDocumentPartId != null ? `?currentDocumentPartId=${currentDocumentPartId}` : "")
    )
    .then((resp) => resp.data);
}

export function exportDocumentRoot(data: TgkImpExpElaborationRequest): Promise<TgkElaborationResponse> {
  return axiosInstance.post(`documentpart/export`, data).then((resp) => resp.data);
}

export function duplicateDocumentRoot(data: TgkDuplicateElaborationRequest): Promise<TgkElaborationResponse> {
  return axiosInstance.post(`documentpart/duplicate`, data).then((resp) => resp.data);
}

export function checkForDuplicate(data: CheckDuplicate): Promise<string[]> {
  return axiosInstance.post(`documentpart/checkforduplicate`, data).then((resp) => resp.data);
}

export function getDocumentHasAttachment(documentId: string): Promise<boolean> {
  return axiosInstance.get(`documentpart/${documentId}/checkusedattachments`).then((resp) => resp.data);
}

export function importDocumentRoot(data: TgkImpExpElaborationRequest): Promise<TgkElaborationResponse> {
  return axiosInstance.post(`documentpart/import`, data).then((resp) => resp.data);
}

export function detachMultilinkedDocumentPart(data: TgkDetachElaborationRequest): Promise<TgkElaborationResponse> {
  return axiosInstance.post(`documentpart/detach`, data).then((resp) => resp.data);
}

export function cloneDocumentPart(data: TgkCloneElaborationRequest): Promise<TgkElaborationResponse> {
  return axiosInstance.post(`documentpart/clone`, data).then((resp) => resp.data);
}

export function downloadDocumentCopyJob(payload: TgkDownloadCopyElaborationRequest): Promise<ArrayBuffer> {
  return axiosInstance
    .post(`downloadCopyDocumentJob`, payload, { responseType: "arraybuffer" })
    .then((resp) => resp.data);
}

export function downloadDocumentCopy(data: DownloadDocumentStructure): Promise<ArrayBuffer> {
  return axiosInstance.post(`downloadCopyDocument`, data, { responseType: "arraybuffer" }).then((resp) => resp.data);
}
